import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Modal } from 'reactstrap';
import classnames from 'classnames';
import 'Assets/EnsembleStyles/EnsHome.css';
import NavigationBar from 'components/EnsembleComponents/Common/Layouts/NavigationBar/Navigationbar';
import TitleBar from 'components/EnsembleComponents/Common/Layouts/TitleBar/TitleBar';
import Footer from 'components/EnsembleComponents/Common/Layouts/Footer/EnsembleFooter';
import ReportsSubRouting from 'components/EnsembleComponents/Common/Layouts/SubRouting/ReportsSubRouting';
import { getUserPreferences } from 'action/cultureAction';
import { AppRolePermission } from 'action/authenticateUser';
import Idle from 'react-idle';
import InactiveWindow from 'components/Logout/InActive';

 
class ManageReports extends Component {

    componentWillMount() {
        this.props.getUserPreferences();
        // this.props.AppRolePermission(5, 18);
        this.props.AppRolePermission(5, 15);
        var E_LogoffTime = localStorage.getItem("AutoLogoffTime");
        if (E_LogoffTime !== undefined && E_LogoffTime !== null && E_LogoffTime !== "") {
            this.setState({ LogOffTime : Number(E_LogoffTime) });
        }
    }
    componentDidMount() {
        let StateVal = (this.props.OnPremises !== undefined && this.props.OnPremises !== null) ? this.props.OnPremises : false;
        this.setState({ OnPremisesState: StateVal });
    }

    componentWillReceiveProps(nextProps) {
        if (this.props !== nextProps) {
            let StateVal = (nextProps.OnPremises !== undefined && nextProps.OnPremises !== null) ? nextProps.OnPremises : false;
            this.setState({ OnPremisesState: StateVal });
        }
    }

    showSettings(event) {
        event.preventDefault();
    }

    constructor(props) {
        super(props);
        this.state = {
            inactive_modal: false,
            OnPremisesState: false,
            LogOffTime: 1200000
        }
        this.Inactivetoggle = this.Inactivetoggle.bind(this);
    }


    Inactivetoggle() {
        this.setState({
            inactive_modal: !this.state.inactive_modal
        });
    }

    Extend_Session = (someArg) => {
        this.Inactivetoggle();
    }

    render() {
        return (
            <div className="Ensemble">
                <Idle timeout={this.state.LogOffTime} onChange={({ idle }) => {
                    if (idle) {
                        this.setState({ inactive_modal: true });
                    }
                }} />
                {
                    !this.state.OnPremisesState ? <div><NavigationBar />
                        <TitleBar parentToChildData={"Reports"} istabView={false} />

                        <div className="Ensemble_Content margin_top">
                             <ReportsSubRouting /> 
                        </div>
                    </div> : <div className="Ensemble_Content_FullPage" style={{"height":"100%"}}>
                     <ReportsSubRouting /> 
                    </div>
                }

                <Modal isOpen={this.state.inactive_modal} inactive_modal={this.inactive_modal} className={classnames({ classnames: this.props.className }, "ModalContainer InActive_Short_Modal")} >
                    <InactiveWindow Extend_Session={this.Extend_Session} />
                </Modal>
                {
                    !this.state.OnPremisesState ? <Footer /> : ""
                }
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        OnPremises: state.authService.IsOnPremise,
    };
};
const mapDispatchToProps = dispatch => {
    return {
        getUserPreferences: () => dispatch(getUserPreferences()),
        AppRolePermission: (actionId, applicationId) => dispatch(AppRolePermission(actionId, applicationId))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ManageReports);
